var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import {} from "@/api";
import { getSelectableObjectStores } from "@/api/objectStores";
import { errorMessageAsString } from "@/utils/simple-error";
export const useObjectStoreStore = defineStore("objectStoreStore", () => {
    const selectableObjectStores = ref(null);
    const loadErrorMessage = ref(null);
    const isLoading = ref(false);
    const isLoaded = computed(() => selectableObjectStores.value != null);
    function loadObjectStores() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isLoaded.value && !isLoading.value) {
                isLoading.value = true;
                try {
                    const data = yield getSelectableObjectStores();
                    selectableObjectStores.value = data;
                }
                catch (err) {
                    const errorMessage = `Error loading Galaxy object stores: ${errorMessageAsString(err)}`;
                    loadErrorMessage.value = errorMessage;
                    console.error("Error loading Galaxy object stores", err);
                }
                finally {
                    isLoading.value = false;
                }
            }
        });
    }
    function getObjectStoreNameById(objectStoreId) {
        var _a, _b;
        const objectStore = (_a = selectableObjectStores.value) === null || _a === void 0 ? void 0 : _a.find((store) => store.object_store_id === objectStoreId);
        return (_b = objectStore === null || objectStore === void 0 ? void 0 : objectStore.name) !== null && _b !== void 0 ? _b : null;
    }
    loadObjectStores();
    return {
        isLoaded,
        isLoading,
        loadErrorMessage,
        selectableObjectStores,
        getObjectStoreNameById,
    };
});
